import React from 'react';
import { ICreateInitial, } from './type';
import { CreateInitial } from './createInitial';
import { reactDomAdapter18 } from './adapters/reactDomAdapter18';

export const CreateInitialReact18 = (
    Component: React.ComponentType<any>
): ICreateInitial => {
    return CreateInitial(Component, reactDomAdapter18);
};